import SocialPrintTemplatePFJoinCode from './SocialPrintTemplatePFJoinCode';
import SocialPrintTemplatePFNoJoinCode from './SocialPrintTemplatePFNoJoinCode';
import SocialPrintTemplateWGJoinCode from './SocialPrintTemplateWGJoinCode';
import SocialPrintTemplateWGNoJoinCode from './SocialPrintTemplateWGNoJoinCode';
import SocialPrintTemplateSellPhotosJoinCode from './SocialPrintTemplateSellPhotosJoinCode';
import SocialPrintTemplateSellPhotosNoJoinCode from './SocialPrintTemplateSellPhotosNoJoinCode';
import { isAlbumFolderForWebGalleryOnly } from '../../../../../../../../util/album-folder';
import { isHumanJoinCode } from '../../../../../../../../util/join-code';

const templateConfiguration = [
  {
    name: 'Sell Photos With Join Code',
    component: SocialPrintTemplateSellPhotosJoinCode,
    when: albumFolder =>
      isHumanJoinCode(albumFolder.join_code) && albumFolder.picture_day_enabled,
  },
  {
    name: 'Sell Photos Without Join Code',
    component: SocialPrintTemplateSellPhotosNoJoinCode,
    when: albumFolder =>
      !isHumanJoinCode(albumFolder.join_code) &&
      albumFolder.picture_day_enabled,
  },
  {
    name: 'WG Only With Join Code',
    component: SocialPrintTemplateWGJoinCode,
    when: albumFolder =>
      isHumanJoinCode(albumFolder.join_code) &&
      albumFolder.is_web_gallery &&
      isAlbumFolderForWebGalleryOnly(albumFolder),
  },
  {
    name: 'WG Only Without Join Code',
    component: SocialPrintTemplateWGNoJoinCode,
    when: albumFolder =>
      !isHumanJoinCode(albumFolder.join_code) &&
      albumFolder.is_web_gallery &&
      isAlbumFolderForWebGalleryOnly(albumFolder),
  },
  {
    name: 'PF With Join Code',
    component: SocialPrintTemplatePFJoinCode,
    when: albumFolder => isHumanJoinCode(albumFolder.join_code),
  },
  {
    name: 'PF Without Join Code // Default Case',
    component: SocialPrintTemplatePFNoJoinCode,
    when: () => true,
  },
];

/**
 * Fetches the correct print template component to be used with the Social prints for marketing materials.
 *
 * @param {Object} options The options.
 * @param {Object} options.albumFolder The AlbumFolder.
 * @returns {{component: function({albumFolder: *}): *, name: string, when: function(*): *}|{component: function({albumFolder: *}): *, name: string, when: function(*): *}|null}
 */
export const getAccountMarketingMaterialSocialPrintTemplateComponent = ({
  albumFolder,
}) => {
  const { component } =
    templateConfiguration.find(config => config.when(albumFolder)) ?? {};
  return component ?? null;
};
